import React from "react";
import {SectionList, View} from "react-native";
import PtText from "../components/core/pt-text/pt-text";
import ScreenTemplate from "./ScreenTemplate";
import {getTranslation} from "../helpers/getTranslation";
import styles from './screen-styles';
import {styleVars} from "../app-style-vars";
import {useSelector} from "react-redux";

/** set this to styles.withBoundaries to display borders around container views to catch layout overflows */
const showBoundaries = null;


const imprintScreenData:any = {
  en: [
    {mainSection: {
      title: 'Corporate Information',
      sections: [
        {title: 'Name and address', data: ['Robert Bosch Limitada','Via Anhanguera, km 98','Vila Boa Vista','13.065-900 – Campinas – SP']},
        {title: 'Your contact at Bosch', data: ['atendimento@br.bosch.com','+55 (47) 3802-2960','+55 19 2103-1954']},
        {title: 'CNPJ', data: ['45.990.181/0001-89']},
        {title: 'State registration', data:['244.007.410.115']}
      ]}
    },
    {mainSection: {
      title: 'Legal Notice',
      sections: [
        {title: '© Copyright', data: ["All rights reserved. Text, images, graphics, sound, animations, and videos as well as the arrangement of the same on Bosch websites are protected by copyright and other commercial protective rights. The content of these websites may not be copied, disseminated, altered, or made accessible to third parties for commercial purposes. In addition, some Bosch websites contain images that are subject to third-party copyrights."]},
        {title: 'Trademarks', data: ["Unless specified otherwise, all trademarks on Bosch websites are protected by trademark law. This applies in particular to Bosch brands, nameplates, company logos, and emblems. The brands and design elements used on our pages are the intellectual property of Robert Bosch GmbH, Germany."]},
        {title: 'Disclaimer', data: ["These websites were compiled with the utmost care. Nonetheless, the accuracy or correctness of the information they contain cannot be guaranteed. Bosch shall not be liable for any loss or damage resulting directly or indirectly from use of these websites, unless caused intentionally or in gross negligence by Bosch."]},
        {title: 'Licensing', data: ["The intellectual property such as patents, marks, and copyrights contained on Bosch websites is protected. These websites do not grant a license for utilizing the intellectual property of companies of the Bosch Group (Bosch) or third parties."]}
      ]}
    }
  ]
  ,
  pt: [
    {mainSection: {
      title: 'Provedor',
      sections: [
        {title: 'Nome e endereço', data: ['Robert Bosch Limitada','Via Anhanguera, km 98','Vila Boa Vista','13.065-900 – Campinas – SP']},
        {title: 'Seu contato na Bosch', data: ['atendimento@br.bosch.com','+55 (47) 3802-2960']},
        {title: 'Sede da Empresa', data: ['+55 19 2103-1954']},
        {title: 'CNPJ', data:['45.990.181/0001-89']},
        {title: 'Inscrição Estadual', data: ['244.007.410.115']}
      ]}
    },
    {mainSection: {
      title: 'Avisos Legais',
      sections: [
        {title: '© Copyright', data: ['Todos os direitos reservados. Os textos, as imagens, o áudio, as animações e os vídeos, assim como a sua disposição nos websites da Bosch estão protegidos por direitos de autor e outros direitos de proteção comercial. O conteúdo destes websites não pode ser copiado, difundido, alterado ou tornado acessível a terceiros para fins comerciais. Além disso, alguns websites da Bosch contêm imagens sujeitas a direitos autorais de terceiros.']},
        {title: 'Informação sobre marcas registradas', data: ['Salvo especificação em contrário, todas as marcas registradas nos websites da Bosch estão protegidas por direitos de propriedade industrial. Isto aplica-se, em particular, às marcas, placas de identificação, logotipos e emblemas da Bosch. As marcas e os elementos de design utilizados nas nossas páginas são propriedade intelectual da Robert Bosch GmbH, Alemanha.']},
        {title: 'Informação sobre garantia', data: ['Este website foi compilado com o máximo cuidado. Não obstante, não é possível garantir a exatidão ou precisão das informações contidas. A Bosch exclui qualquer responsabilidade por danos resultantes direta ou indiretamente da utilização deste website, exceto no caso de má conduta ou negligência grave e intencional da parte da Bosch.']},
        {title: 'Informação sobre licença', data: ['A propriedade intelectual contida no website da Bosch, p. ex., patentes, marcas e direitos autorais, está protegida. Este website não concede qualquer licença para a utilização da propriedade intelectual das empresas do Grupo Bosch (Bosch) ou de terceiros.']}
      ]}
    }
  ]
}
;

export default function ImprintScreen({navigation, route}:any) {

  const currentLanguage:string = useSelector((state:any) => state.translationsReducer.currentLanguage);

  const mainSectionHeaderRender = ({mainSection}:any, idx:number) => {
    return (
      <View style={[styles.pageContentSlotContainer, showBoundaries]} key={`imprintMainSection_${idx}`}>
        <PtText style={{fontSize: styleVars.rem(1.5), paddingVertical: styleVars.rem(.5)}}>{mainSection.title}</PtText>
      </View>
    );
  };

  const sectionItemrender = ({item}:any) => {
    return (
      <PtText style={{textAlign: 'justify', fontSize: styleVars.rem(.875)}}>{item}</PtText>
    );
  };

  const sectionHeaderRender = ({section}:any) => {
    return (
      <PtText style={{fontSize: styleVars.rem(1), paddingVertical: styleVars.rem(.5)}}>{section.title}</PtText>
    );
  };

  return (
    <ScreenTemplate navigation={navigation} route={route}>

      <View style={[styles.pageContentSlotContainer, showBoundaries]}>
        <View style={{paddingVertical:styleVars.rem(3), backgroundColor:styleVars.boschLightGrayW75}}>
          <PtText headline={true} style={{textAlign:'center'}}>{getTranslation('imprint.title')}</PtText>
        </View>
      </View>

      {imprintScreenData[currentLanguage].map((screenSection:any, idx:number) => (
        [
          mainSectionHeaderRender(screenSection, idx)
          ,
          <View style={[styles.pageContentSlotContainer, showBoundaries]} key={`imprintSubsection_${idx}`}>
            <SectionList
              sections={screenSection.mainSection.sections}
              renderItem={({item}) => sectionItemrender({item}) }
              renderSectionHeader={({section}) => sectionHeaderRender({section})}
              keyExtractor={(item, index) => item + index}
            />
          </View>
        ]
      ))}

      <View style={[styles.pageContentSlotContainer, showBoundaries, {paddingBottom: styleVars.rem(1)}]}></View>
    </ScreenTemplate>
  )
}